import React, { useEffect, useState } from 'react';

//Components
import MainCard from '../../components/MainCard/MainCard'
import TabelaListagem from '../../components/TabelaListagem/TabelaListagem'
import { actionsTable } from '../../constants/MaterialTable';
import AutoDeInfracaoImpressao from '../../views/Shared/AutoDeInfracaoImpressao';

//Context
import { useAuth } from '../../context/auth';

//Helpers
import { showMessage } from 'helpers/message';

//API
import autoInfracao_api from '../../api/autoInfracao_api';

export default function ConsultaAutosInfracao() {
    const { setLoading } = useAuth();

    //Estado que guarda os dados da tabela
    const [listaAutosInfracoes, setListaAutosInfracoes] = useState([]);

    const [visualizacaoAutoInfracao, setVisualizacaoAutoInfracao] = useState(null);

    //Headers da tabela
    const headers = [
        { value: "Tipo notificação", objectValue: "tipoNotificacao" },
        { value: "Preceitos Legais", objectValue: "preceitosLegais" },
        { value: "Fato Constitutivo", objectValue: "fatoConstitutivo" }, 
        { value: "Data de cadastro", objectValue: "dataCadastro" },
        { value: "Valor da multa", objectValue: "valorMulta" }
    ];

    function handleVisualizarAutoInfracao(rowData) { 
        setVisualizacaoAutoInfracao(rowData);
    };

    const actions = [actionsTable.visualizar(handleVisualizarAutoInfracao)];

    async function loadAutosInfracoes() {
        setLoading(true);
        try {
            const { data } = await autoInfracao_api.GetList();
            setListaAutosInfracoes(data || []);
        } catch (error) {
            showMessage("Error", error.mensage, "error", null);
        }finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        loadAutosInfracoes();
    }, []);


    if(!!visualizacaoAutoInfracao){
       return <AutoDeInfracaoImpressao 
            hash={visualizacaoAutoInfracao.hash} 
            handleReturn={() => { 
                setVisualizacaoAutoInfracao(null);
                loadAutosInfracoes();
            }}
        />
    }

    return (
        <MainCard 
            noCard 
        > 
            <TabelaListagem 
                title='Lista de autos de infrações'
                headers={headers}
                items={listaAutosInfracoes}
                actions={actions}
                options={{ print: false, search: true, pagination: true }}
            />
        </MainCard>
    )
}
